import { Component, Input, OnInit } from '@angular/core';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { ModalController } from '@ionic/angular';
import * as moment from 'moment';
import { ApiserviceService } from 'src/app/services/apiservice.service';
import { Chooser,ChooserResult } from '@ionic-native/chooser/ngx';


@Component({
  selector: 'app-cargardoc',
  templateUrl: './cargardoc.page.html',
  styleUrls: ['./cargardoc.page.scss'],
})
export class CargardocPage implements OnInit {

  filescel=[];
  files=[];
  mime="image/*";//.pdf
  @Input()tipo
  @Input()raiz 
  @Input()identificador
  @Input() carpeta
  @Input() folder
 

  impri="";

  fileTransferobj: FileTransferObject;
  
  plataforma


  constructor( 
     public apiservice: ApiserviceService,
      private modalCtrl:  ModalController,
      private fileTransfer: FileTransfer,
      private fileChooser: FileChooser,
      private chooser:Chooser,
      private androidPermissions: AndroidPermissions,
      ) { 

        this.fileTransferobj = this.fileTransfer.create();

      }


  ngOnInit() {

 
  }


  ionViewWillEnter(){

    this.plataforma=this.apiservice.plataforma()[0]['desktop']; 

  /////////////////////////////////////////////////////////////////
  document.getElementById('area').addEventListener("dragover",(e)=>{
    e.preventDefault();

    document.getElementById('area').classList.add('active');
    document.getElementById('texto').textContent="Suelta para subir los archivos";

    });
    
    document.getElementById('area').addEventListener("dragleave",(e)=>{
    e.preventDefault();
    document.getElementById('area').classList.remove('active');
    document.getElementById('texto').textContent="Arrastre y suelte los Archivos";

    });
    
    document.getElementById('area').addEventListener("drop",(e)=>{
    e.preventDefault();
   this.files=Array.from(e.dataTransfer.files);

    console.log(this.files);

    document.getElementById('area').classList.remove('active');
    document.getElementById('texto').textContent="Arrastre y suelte los Archivos";

    });


/*
    document.getElementById('input-file').addEventListener("change",(e)=>{
      e.preventDefault();
      console.log('cambio...');

      
      

      //document.getElementById('input-file').files
      var fileInput = document.getElementById('input-file');
        var files = fileInput.files;

      console.log(e);

      document.getElementById('area').classList.add('active');

    });
*/

  }

 

    


  //////////////////////////////////////////////////////////////////




  regresar(){

    this.modalCtrl.dismiss();
    
  }

  onFileSelected(event: any) {
   
    const files: File[] = event.target.files;
    this.files=event.target.files;
    console.log(this.files); 
  
  } 

/*
cargarcel(){

  this.apiservice.mensaje('cargando tranfer..','success');

  ////////////////////////////////////////  
  console.log(this.files);
  ///////////////////////////////////////
  // const file = event.target.files[0];
   var fileUrl = this.files[0].nativeURL;

   console.log(fileUrl);

   //////////////////////////////////////

   const serverUrl = 'https://tu-servidor.com/upload'; // Reemplaza con la URL de tu servidor
    const options = {
      fileKey: 'file', // El nombre del campo de archivo en el formulario
      headers: {},
    };

    this.fileTransferobj.upload(fileUrl, serverUrl, options)
      .then((data) => {
        // Éxito al cargar el archivo
        console.log('Archivo cargado con éxito:', data.response);
      })
      .catch((err) => {
        // Error al cargar el archivo
        console.error('Error al cargar el archivo:', err);
      });


}
*/



  cargar(){


    ///pregunto si la carga es para celular o para destok....

    /// esto funciona con Destok......
    console.log('cargando...');
    document.getElementById('input-file').click();
    ///////////////////////////////////////////////////////

    //debo crear para celular.....

    /// debo crear q tipo de archivo es si es una imagen  o si es un archiva guardado en el cel.....

  }

  eliminar(a){


    var auxfiles=[];

    for(var i=0;i<this.files.length;i++){

      if(this.files[i]['name']!=a.name)
      auxfiles.push(this.files[i]);

    }

    console.log(auxfiles);

    this.files=auxfiles;

   // console.log(this.files);
   // console.log(this.files[0]);
   // console.log(this.files[0]['name']);

      

  //this.files=filtro;

  }

  convbase64(pos){

    // const file = e.dataTransfer.files[0];

    
    if(this.files.length>pos){

      const reader = new FileReader();
      
      reader.onload = (event)=> {
        const base64Content = event.target.result;
        console.log(base64Content); // Base64-encoded content

       ///////////////////////////////////////////////

      // var formData = new FormData();
      // formData.append('file', new Blob([event.target.result], { type:  this.files[pos].type }), this.files[pos].name);
       

       ///////////////////////////////////////////////
       this.impri=base64Content.toString();

        this.files[pos]['base64']=base64Content;
        if(!this.files[pos]['estado'])
        this.files[pos]['estado']=false; 

        this. convbase64(pos+1)
      };
      
      
      var dataf= reader.readAsDataURL(this.files[pos]);
  
    }else
    {
      this.subir();
    }
  
  }

  
  subircelchooser(pos){


    if(pos==0){this.apiservice.startloading();}

    const fileTransfer: FileTransferObject = this.fileTransfer.create();

    //{'filePath':filePath,'estado':false}
if( this.files.length>pos){

  if(!this.files[pos]['estado']){

    let options = {
      fileKey: 'archivo',
      fileName: this.files[pos]['filePath'].name,
      chunkedMode: false,
      mimeType: 'multipart/form-data',
      params : {
        'nombre':this.files[pos]['filePath'],
        'extension':this.files[pos]['filePath'].mediaType,
        'ruta':this.folder['url']},
      headers: {}
    };
    
      fileTransfer.upload(this.files[pos]['filePath'].uri, encodeURI("https://oilandgas.com.co/appdocumentos/upload.php"), options)
      .then((data) => {
        // Manejar la respuesta del servidor
        console.log(data.response);
        this.files[pos]['estado']=true;
        this.subircelchooser(pos+1)

      }, (err) => {
        // Manejar errores
        console.log(err);

        this.apiservice.mensaje('Error cargando...','danger')
      });
      
    }else{
      this.subircelchooser(pos+1)
    }

   

  }else{

    if(this.files.length>0){

    setTimeout(() => {
      this.apiservice.closedloading();

      var auxfil=[];
      for(var f=0;f<this.files.length;f++){
    
        auxfil.push({
        
          'estado':false,
          'name':this.files[f]['name'],
          'subfolders':[],
          'tipo':'1',
          'aux':'0',
          'url':this.folder.url+this.files[f]['name'],
          'visible':true
              });   
            }



      this.modalCtrl.dismiss(auxfil);
    }, 1500);
    
    }
  }



  }


  async cargarcelchoose(){

    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE)
    .then(
      result => console.log('Has permission?',result.hasPermission),
      err => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE)
    );


     const permission = await this.androidPermissions.requestPermission(
      this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE
    );


    this.chooser.getFile().then(filePath => {

     // eliminar(
      this.files.push({'filePath':filePath,'estado':false,'name':filePath.name})

      console.log("filePath.dataURI")
      console.log(filePath.dataURI);
      console.log('filePath.data')
      console.log(filePath.data)
      console.log('filePath.mediaType')
      console.log(filePath.mediaType)
      console.log('filePath.name')
      console.log(filePath.name)
      console.log('filePath.uri')
      console.log(filePath.uri)

    
    

    });


  }



  faltan(){

    var sum=0;
    for(var i=0;i<this.files.length;i++){
      if(!this.files[i].estado){sum++}
    }

    return sum;


  }

  async subir(){

console.log(this.files);

this.apiservice.startloading();
for(var a=0;a<this.files.length;a++){

var formData = new FormData();
//formData.append('archivo', new Blob([this.files[a]['base64']], { type:  this.files[a].type }), this.files[a].name);
//formData.append('tipo', this.tipo);  //1-->soportes apl, 2-->soportes inspecciones.
formData.append('archivo', this.files[a]);
//formData.append('nombreCarpeta',this.carpeta);   
//formData.append('raiz',this.raiz); 
formData.append('ruta',this.folder['url']); 
//formData.append('identificador',this.identificador);  

//  this.files[a]['base64']="xx";

var rrta=this.folder
console.log(this.folder);
/*
var arc={
  
  'id':moment().format("yyyy-MM-DD HH:mm:ss"),
  'nombre':this.files[a].name,
  'identificador':this.identificador,
  'carpeta':this.carpeta,
  'raiz':this.raiz
  
}
formData.append('tipo',this.tipo);
formData.append('id',arc['id']);
formData.append('info',JSON.stringify(arc));*/

if(!this.files[a]['estado']){

  var res=(this.files[a]['size']/1024);

if(1024>(this.files[a]['size']/1024)){


var resmod=await this.apiservice.postapi2up(formData);
console.log(resmod);

if(resmod['idcod']=='1'){this.files[a]['estado']=true}
else{
  this.apiservice.mensaje('Error cargando archivo','danger');
}


}
else{
  this.apiservice.mensaje('Error el archivo es muy pesado','danger');
}

}

}


setTimeout(() => {
  this.apiservice.closedloading();

  var auxfil=[];
  for(var f=0;f<this.files.length;f++){

    auxfil.push({
    
      'estado':false,
      'name':this.files[f]['name'],
      'subfolders':[],
      'tipo':'1',
      'aux':'0',
      'url':this.folder.url+this.files[f]['name'],
      'visible':true
          });   
        }
  this.modalCtrl.dismiss(auxfil);
}, 2000);



// apl
// moment --> pk
// file (base64)
// nombre delarchivo -- unique.

// nota : debe existir la forma de eliminar los archivos....

//comienzo a subir los archivos
 // this.files[0]['estado']=true;


  }

}
